import axios from 'axios';
import { API_BASE_URL as BASE_URL } from '../../config/api';

const API_BASE_URL = `${BASE_URL}/api/v1/meeting-applications`;

// 모임 신청서 작성
export const postMeetingApplication = async (meetingId, applicationData) => {
    const response = await axios.post(`${API_BASE_URL}/${meetingId}`, applicationData, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};

// 내가 작성한 모임 신청서 목록 조회
export const getMyMeetingApplications = async () => {
    const response = await axios.get(`${API_BASE_URL}/my`);
    return response.data;
};

// 모임 신청서 단건 조회
export const getMeetingApplication = async (meetingApplicationId) => {
    const response = await axios.get(`${API_BASE_URL}/${meetingApplicationId}`);
    return response.data;
};

// 모임 신청서 삭제
export const deleteMeetingApplication = async (meetingApplicationId) => {
    const response = await axios.delete(`${API_BASE_URL}/${meetingApplicationId}`);
    return response.data;
};

// 모임 신청서 다건 조회 (모임에 해당되는)
export const getMeetingMeetingApplications = async (meetingId) => {
    const response = await axios.get(`${API_BASE_URL}/by-meeting/${meetingId}`);
    return response.data;
};

// 모임 신청서 승인
export const acceptMeetingApplication = async (meetingApplicationId, acceptRequest) => {
    const response = await axios.patch(`${API_BASE_URL}/${meetingApplicationId}`, acceptRequest, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};